import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../helpers/reducerRegistry'
import { GDP_TAB } from '../../../constant'

const slice = createSlice({
  name: 'industry/industryOverview/macroeconomics/gdp/gdpChart/chartGrowthRateGDP',
  initialState: {
    tab: GDP_TAB.REAL_GDP.key,
    isShowData: true,
  },
  reducers: {
    changeTab: (state, action) => {
      state.tab = action.payload
    },
    changeIsShowData: (state, action) => {
      state.isShowData = action.payload
    },
  },
})

export const selectTab = (state) => state[slice.name].tab
export const selectIsShowData = (state) => state[slice.name].isShowData

export const { changeTab, changeIsShowData } = slice.actions

register(slice.name, slice.reducer)
